import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import "../../../investor/investor.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { Modal } from "react-bootstrap";
import { SBADropDown } from "../../../UiComponents/SBADropDown";
import { getContactRelatedContactsAction, getContactRelationTypesAction} from "../../../actions/investorAccounts";
import { deleteContactRelation, insertOrUpdateContactRelation, getActivityEntity} from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";
export const Relationships = (props) => { 
  const locationData = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const isInitialLoad = useRef(true);
  useEffect(() => {
      document.title = `Investor Details`;
      if (isInitialLoad.current) {
      dispatch(getContactRelatedContactsAction(params.ContactId));
      dispatch(getContactRelationTypesAction());
      getEntities();
      isInitialLoad.current = false;
      }
  }, []);
    const Gstate = useSelector((state) => state) || {};
 
    const isEditable = Gstate.authorizationData.isEditable;
    const RelatedContactGridLoading = useSelector((state) => state.investorAccounts.isRelatedContactLoading);
    const GridRelatedContatdata = Gstate?.investorAccounts.RelatedContact || [];
    const relationtypes = Gstate?.investorAccounts.RelationTypes || [];

    const [showDrawer, setshowDrawer] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [Mode, setMode] = useState([]);
    const [selectedRelationship, setselectedRelationship] = useState([]);
    const [selectRelatedContactName, setselectRelatedContactName] = useState([]);
    const [DelLinkedId, setDelLinkedId] = useState([]);
    const [selectednotes, setselectednotes] = useState("");
    const [selectedContactRelationId, setselectedContactRelationId] = useState([]);
    const [Contactlist, setContactlist] = useState([]);

    const ActionsRenderer = (props) => {
        const Editdata = props.data;
        const delRelationship = props.data.LinkedId;
        const handleEditClick = () => {
            if (isEditable !== false ) {
                setselectRelatedContactName({ "RelatedContactId": Editdata.RelatedContactId,"RelatedContactName":Editdata.RelatedContactName });
                setselectedRelationship({ "ContactRelationTypeId": Editdata.ContactRelationTypeId, "ContactRelationTypeName": Editdata.ContactRelationTypeName})
                setselectednotes(Editdata.Notes);
                setselectedContactRelationId(Editdata.ContactRelationId)
                setshowDrawer(true);     
                setMode('Edit');
            }
        }
        const handleDeleteClick = () => {
            if (isEditable !== false ) {
                setShowModal(true);
                setDelLinkedId(delRelationship);
            }
        };

        return (

            <div className="actions-cell">
                <i className="fas fa-edit" style={{ color: isEditable === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}></i>
                <i
                    className="fas fa-trash"
                    style={{ color: isEditable === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };

    //const DeleteActionsRenderer = (props) => {
    //    const delRelationship = props.data.LinkedId;
       
    //    const handleDeleteClick = () => {
    //        setShowModal(true);
    //        setDelLinkedId(delRelationship);
           

    //    };
    //    return (
    //        <div className="actions-cell">
    //            <i
    //                className="fas fa-trash"
    //                style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
    //                onClick={handleDeleteClick}
    //            ></i>
    //        </div>
    //    );
    //};

    const onDeleteClick = () => {      
        sbaAxios({
            url: `${deleteContactRelation}${DelLinkedId}`,
            method: 'get',
        }).then(() => {
            setShowModal(false);
            SBNotify({ Msg: "Selected Relation contact Deleted Successfully", type: "success" });
            dispatch(getContactRelatedContactsAction(params.ContactId));
        }).catch(() => {
            SBNotify({ Msg: "sone error  occured", type: "error" });
        })


    }
    
    const closeModal = () => {
        setshowDrawer(false);
       
        setShowModal(false);
    };

    const getEntities = async () => {
        try {

            const response = await sbaAxios({
                url: `${getActivityEntity}ActivityEntityTypeIds=${0}&SearchString=${null}&activitySourceId=2`,
                method: 'get',
            });
            response?.map((item) => {
                setContactlist(prevList => [
                    ...prevList,
                    { "RelatedContactId": item.EntityId, "RelatedContactName": item.EntityName }
                ]);
            });
            
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

    

    const onAddButtonClick = () => {
        setshowDrawer(true);
        setMode('Add');
        setselectedRelationship([]);
        setselectednotes([]);
        setselectRelatedContactName([]);
    }

    const Relationshipchange = (e) =>
    {
        setselectedRelationship(e.value);
    }

    const Contactchange = (e) => {
        setselectRelatedContactName(e.value);
       
    }

    const saveRelationship = () => {
     
       
        let ifsave = true;
        const savedata = {

            "contactRelationId": Mode === "Add" ? 0 : selectedContactRelationId,
            "contactId": params.ContactId,
            "relatedContactId": selectRelatedContactName.RelatedContactId,
            "contactRelationTypeId": selectedRelationship.ContactRelationTypeId,
            "notes": selectednotes.length!==0?selectednotes:" ",
            "modifiedBy": 0
        }

        if (!selectRelatedContactName.RelatedContactId || selectRelatedContactName.RelatedContactId === 0 || selectRelatedContactName.RelatedContactId === "") {
            ifsave = false;
            SBNotify({ Msg: "Please choose Contact", type: "error" });
        }
        if (!selectedRelationship.ContactRelationTypeId || selectedRelationship.ContactRelationTypeId === 0 || selectedRelationship.ContactRelationTypeId === "") {
            ifsave = false;
            SBNotify({ Msg: "Please choose Relation", type: "error" });
        }

        if (ifsave) {
            sbaAxios({
                url: `${insertOrUpdateContactRelation}`,
                method: "post",
                data: savedata,
            }).then((response) => {
                closeModal();

              
                SBNotify({ Msg: "Relation Add/ Update Successfully", type: "success" });
                dispatch(getContactRelatedContactsAction(params.ContactId));
               
            }).catch((error) => {
                SBNotify({ Msg: "sone error  occured", type: "error" });
            });
        }    

    }
  


    const ColumnDef = [
        
        {
            headerName: "Contact Name", field: "RelatedContactName", tooltipValueGetter: function (params) {
                return params.data.RelatedContactName;
            },
        },
        {
            headerName: "Business Email", field: "BusinessEmail",
            tooltipValueGetter: function (params) {
                return params.data.BusinessEmail;
            },
        },
        {
            headerName: "Business Phone", field: "BusinessPhone"
        },
        {
            headerName: "Relationship", field: "ContactRelationTypeName"
        },
        {
            headerName: "Type", field: "ContactRelationCategoryName"
        },
        
        {
            headerName: "Notes", field: "Notes"
        },

        {
            field: "Action",
            headerName: "Action",
            cellRenderer: ActionsRenderer,
            filter: false,
            maxWidth: 130,
        },

       
    ];


    const defaultColDef = {
        sortable: false,
        filter: false,
        suppressMovable: true,
        flex: 1,
        resizable:true
    };
    

  return (
    <>            
          <div>

              <div className="w-100 d-flex justify-content-end p-2">
                  <button type="submit" className="p-sm-btn mx-1" disabled={!isEditable} onClick={() => onAddButtonClick()}><i className="fa-solid fa-plus" /> Add </button>

              </div>
             
                  <div className="p-2">
                  {RelatedContactGridLoading ? (
                      <LoadingScreen />
                  ) : (
                          <div className="ag-theme-alpine" style={{ height: 500 }}>
                              <AgGridReact
                                  
                                  enableBrowserTooltips={true}                               
                                  columnDefs={ColumnDef}
                                  rowData={GridRelatedContatdata}
                                  defaultColDef={defaultColDef}
                                  
                                
                              />
                          </div>
                  )}
              </div>

              <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Relationship Add / Edit'}>
                  <div>
                      <div>
                         
                          <label className="header-container m-1">
                              <b>Relationship:</b>
                              </label>

                          <div>
                              <SBADropDown
                                  className="w-50"
                                  textField={"ContactRelationTypeName"}
                                  valueField={"ContactRelationTypeId"}
                                  data={relationtypes}
                                  onChange={Relationshipchange}
                                  popupSettings={{ className: 'modalDD' }}
                                  value={selectedRelationship}

                              />
                          </div>
                          <br></br>
                          <label className="header-container m-1">
                              <b>Contact:</b>
                          </label>
                          {Mode === "Add" ? (<div>
                              <SBADropDown
                                  className="w-50"
                                  textField={"RelatedContactName"}
                                  valueField={"RelatedContactId"}
                                  data={Contactlist}
                                  onChange={Contactchange}
                                  popupSettings={{ className: 'modalDD' }}
                                  value={selectRelatedContactName}
                              />
                          </div>) : (<div> {selectRelatedContactName.RelatedContactName}    </div> )}

                          <br></br>
                          <label className="header-container m-1">
                              <b>Notes:  </b>  
                          </label>
                          

                          <div>
                          <input                         
                                  className="form-control w-50"
                                  type="text"
                                  value={selectednotes}
                                  onChange={(e) => setselectednotes(e.target.value)}
                              />
                          </div>
                      </div>
                      <div className="mt-4">
                          <button className="s-sm-btn mx-1" onClick={closeModal}>
                              Cancel
                      </button>
                          {Mode === "Add" ?( <button className="p-sm-btn mx-1" onClick={saveRelationship}>
                              Add 
                          </button>) : (<button className="p-sm-btn mx-1" onClick={saveRelationship}>
                              Update
                          </button>)}

                      </div>
                  </div>
              </SBADrawer >
              {<Modal show={showModal}>
                  <Modal.Header closeButton onClick={closeModal}>
                      <Modal.Title>Do you want to delete the selected Menu?</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <p>The selected Menu will be deleted permanently. Are you sure?</p>
                  </Modal.Body>
                  <Modal.Footer>
                      <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                      <button className='p-sm-btn mx-1' onClick={onDeleteClick} >
                          Yes
          </button>
                  </Modal.Footer>
              </Modal>}
             
          </div>
            
          
    </>
  );
};
